import { takeEvery, all, fork, put } from "redux-saga/effects";
import { SET_BUSINESS_ALL_DETAIL_REQUEST, SET_BUSINESS_DETAIL_FROM_LIST_REQUEST, BUSINESS_PROFILE_SAVE_SUPER, TOGGLE_DISABLED_BUSINESS, TOGGLE_DISABLED_BUSINESS_PROFILE } from "../constants/ActionTypes";
import { push } from "react-router-redux";
import axios from "../services/customer";
import admin from "../services/admin";
import * as actions from "../actions";
import { formatPhone } from "../util/normalizePhone";
import { isWebview } from "../util/generalFunction";

function* getBusinessList(action) {
  try {
    const response = yield axios.get(`/businesses`);
  
    yield put(actions.requestBusinessListSuccess(response.data));
  } catch (error) {
    if (error.message.indexOf("404") >= -1) {
      console.log("page not found");
      yield put(push("/Error404"));
    }
  }
}

function* getBusinessDetail(action) {
	console.log("TCL: function*getBusinessDetail -> action", action)
  try {
    const response = yield axios.get(`/businesses/${action.payload}`);
    let temp = response.data;
		console.log("TCL: function*getBusinessDetail -> temp", temp)
		const data = {
      businessname: temp.name, 
      website: temp.website,
      email: temp.owner_details.email,
      oldemail: temp.owner_details.email,
      phonenumber: formatPhone(temp.business_locations[0].phonenumber),
      description: temp.description,
      address: temp.business_locations[0].address,
      _id: temp._id,
      firstname: temp.owner_details.firstname,
      lastname: temp.owner_details.lastname,
      title: temp.owner_details.title,
      newPassword: "",
      confirmPassword: "",
      userId: temp.owner_details._id,
      location_id: temp.business_locations[0]._id,
      businesstype: temp.business_type[0]._id,
      imageFile: temp.logo,
      editData: true,
      is_disabled: temp.is_disabled,
      exception_based_availability: temp.business_locations[0].exception_based_availability,
      noOfEmployee: temp.business_locations[0].no_of_employee,
      currentEmployee: temp.business_locations[0].employees_working.length
    } 
    yield put(actions.getBusinessDetailSuccess(data));
    // localStorage.setItem('business_location', data.location_id)
    // console.log("TCL: function*getBusinessDetail -> data.location_id", data.location_id)
    isWebview()
    ? yield put(push("/SuperAdminMobileScreen"))
    : yield put(push("/super-admin/businessprofile"));
  } catch (error) {
    if (error.message.indexOf("404") >= -1) {
      console.log("page not found");
      yield put(push("/Error404"));
    }
  }
}

function* businessProfileSave({ payload }) {
  console.log("TCL: function*businessProfileSave -> payload", payload)
  try {
    const {
      email,
      oldemail,
      businessname: name,
      phonenumber,
      description,
      website,
      address,
      _id,
      imageFile,
      firstname,
      lastname,
      title,
      userId,
      newPassword,
      confirmPassword,
      location_id,
      businesstype,
      editData,
      exception_based_availability,
      noOfEmployee
    } = payload;
		
    if(editData) {
      const businesslocations = location_id;

      const email1 = email === oldemail ? null : email;
      const password = newPassword.length === 0 ? null : newPassword;

      const response = yield axios.put(`/businesslocations/${businesslocations}`, {
        address,
        phonenumber,
        exception_based_availability,
        no_of_employee: noOfEmployee
      });

      const response2 = yield axios.put(`/businesses/${_id}`, {
        name,
        description,
        website
      });
      let imageResponse = null;
      let imageData = null;

      if (imageFile) {
        console.log("TCL: function*businessProfileSave -> imageFile", imageFile)
        console.log('payload.imageid', payload.imageid)
        if(payload.imageid != "") {
        console.log('payload.imageid 1', payload.imageid)
        yield admin.delete(`/upload/files/${payload.imageid}`);
        }
        const file = new FormData();
        file.append("files", imageFile);
        file.append("refId", _id);
        file.append("ref", "business");
        file.append("field", "logo");

        imageResponse = yield axios.post("/upload?files", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      const myObject = {
        firstname,
        lastname,
        title,
      };

      if (email1) {
        myObject.email = email1;
      }
      if (password) {
        myObject.password = password;
      }

      const response3 = yield axios.put(`/users/${userId}`, myObject);

    } else {

      const response = yield axios.post(`/users`, {
        email,
        role: "5bce80b7ace4410016946d8b",
        firstname,
        lastname,
        password: newPassword,
        username: email,
        title
      });

      

      const response1 = yield axios.post(`/businesses`, {
        name,
        description,
        website,
        business_type: [businesstype],
        business_slug: "",
        owner_details: response.data._id
      });
      
      const response2 = yield axios.post(`/businesslocations`, {
        businessname: response1.data._id,
        branch_name: name+"-USA",
        address,
        timezone: "",
        operations: {},
        phonenumber,
        email,
        owner_details: response.data._id,
        exception_based_availability,
        no_of_employee: noOfEmployee
      });
      let imageResponse = null;
      if (imageFile) {
        const file = new FormData();
        file.append("files", imageFile);
        file.append("refId", response1.data._id);
        file.append("ref", "business");
        file.append("field", "logo");

        imageResponse = yield axios.post("/upload?files", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }
    }
    getBusinessList();
    isWebview()
    ? yield put(push("/SuperAdminMobileScreen"))
    : yield put(push("/super-admin/businesses"));
    
    yield put(actions.closureOnhideLoader());
  } catch (error) {
		// console.log("TCL: error", error)
    
    yield put(actions.failResponseMessage(error.response.data.message));
  }
}

function* toggleDisabledBusiness({payload}) {
  try {
    const { _id, is_disabled } = payload;
		const response = yield axios.put(`/businesses/${_id}`, {
      is_disabled: !is_disabled
    });
    yield put(actions.requestBusinessList());
  } catch (error) {
    yield put(actions.failResponseMessage(error.response.data.message));
  }

}

function* toggleDisabledBusinessProfile({payload}) {
  try {
    const { _id, is_disabled } = payload;
		const response = yield axios.put(`/businesses/${_id}`, {
      is_disabled: !is_disabled
    });
    yield put(actions.requestBusinessDetail(_id));
  } catch (error) {
    yield put(actions.failResponseMessage(error.response.data.message));
  }

}

export function* requestBusinessList() {
  yield takeEvery(SET_BUSINESS_ALL_DETAIL_REQUEST, getBusinessList);
}

export function* requestBusinessDetail() {
  yield takeEvery(SET_BUSINESS_DETAIL_FROM_LIST_REQUEST, getBusinessDetail);
}

export default function* rootSaga() {
  yield all([
    fork(requestBusinessList),
    fork(requestBusinessDetail),
    takeEvery(BUSINESS_PROFILE_SAVE_SUPER, businessProfileSave),
    takeEvery(TOGGLE_DISABLED_BUSINESS, toggleDisabledBusiness),
    takeEvery(TOGGLE_DISABLED_BUSINESS_PROFILE, toggleDisabledBusinessProfile)
  ]);
}


// WEBPACK FOOTER //
// ./sagas/BusinessSaga.js